import { render, staticRenderFns } from "./shoppingCard.vue?vue&type=template&id=577dc72d&scoped=true&"
import script from "./shoppingCard.vue?vue&type=script&lang=js&"
export * from "./shoppingCard.vue?vue&type=script&lang=js&"
import style0 from "./shoppingCard.vue?vue&type=style&index=0&id=577dc72d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577dc72d",
  null
  
)

export default component.exports